  <div [ngClass]="isCustomHeight ? 'post-upper-body': ''">
    <div class="post-header p-3 d-flex">
        <div class="profile-icon profile-img-post">
            <!-- <span class="img-prof" *ngIf="postData.user_image; else dummyimage"><img src="{{postData.user_image}}" alt="team"></span>
            <ng-template #dummyimage>
                <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
            </ng-template> -->

            <ng-container *ngIf="profileUrl">
              <span class="img-prof" ><img src="{{profileUrl}}" alt="icon"  alt="team"></span>
            </ng-container>
            <ng-container *ngIf="!profileUrl && customProfileName">
              <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">{{customProfileName}}</div>
            </ng-container>
            <ng-container *ngIf="!profileUrl && !customProfileName">
              <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
            </ng-container>
        </div>
        <div class="profile-name-type">
            <div *ngIf="postData.userName; else dummyName">
                <h5>{{postData.userName}}</h5>
            </div>
            <ng-template #dummyName>
                <div>
                    <h5>Guest User</h5>
                </div>
            </ng-template>
            <div class="timing-category">
                <!-- <div class="time-ago">{{postData.created_date | prettyDate}}</div> -->
                <div class="time-ago">{{postData.created_date}}</div>
                <!-- <div class="breaker">o</div> -->
                <div>{{postData.forum_subject_name}}</div>
            </div>
        </div>
        <div class="dropdown post-options">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <img src="assets/images/icon.svg" alt="arrow-right" class="">
                  </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a *ngIf="isLoggedin" class="dropdown-item" href="#"><img class="mr-2" src="assets/images/bookmark.svg" alt="bookmark"> Save Post</a>
                <a *ngIf="isLoggedin" class="dropdown-item" href="#"><img class="mr-2" src="assets/images/duplicate.svg" alt="duplicate"> Duplicate</a>
                <a class="dropdown-item" href="javascript:void(0)" (click)="reportPost()"><img class="mr-2" src="assets/images/flag.svg" alt="flag"> Report</a>
            </div>
        </div>
    </div>

    <div class="px-3">
        <div class="scroll-container ps" fxFlex="auto" [perfectScrollbar]="perfectconfig" (psXReachEnd)="onScrollEvent($event)" (psYReachEnd)="onScrollEvent($event)" (psXReachStart)="onScrollEvent($event)" (psYReachStart)="onScrollEvent($event)">
            <div class="scrollable-content">
                <div class="post-category d-flex">
                    <ng-container *ngFor="let category of postData.forum_category">
                        <div class="tagx badge badge-primary">{{category.category_name | uppercase | removeHiphen}}</div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="post-desc px-3">
        <span class="verified-post-tag" *ngIf="postData.expert_verified ==='1'"><img src="assets/images/check.svg" alt="verify"> Expert Verified Post</span>
        <div class="profile-name-type">
            <a routerLink="{{baseUrl}}discuss-detail/{{postData.forum_slug}}" *ngIf="postData.forum_title">
                <h5>{{postData.forum_title}}</h5>
            </a>
        </div>
        <a routerLink="{{baseUrl}}discuss-detail/{{postData.forum_slug}}" *ngIf="postData.short_description"><span>{{postData.short_description}}...</span></a>
    </div>
    <div class="post-thumbnail px-3" *ngIf="postData.image">
        <a (click)="showPreviewImage(postData.image)"><img src="{{imageUrl}}{{postData.image}}" alt="post image" style="max-width: 350px;
          height: auto;"></a>
    </div>
    <div class="mcq-option-box" *ngIf="postData.forum_type == 'mcq'">
        <mcq-post [post]='postData'></mcq-post>
    </div>

</div>

<!-- <div class="view-post-btn p-1">
            </div> -->
<div [ngClass]="isCustomHeight ? 'post-footer': 'post-footer post-expand'">

    <div class="custom-footer p-2">
        <span class="count-category text-left">
                    <span>{{postData.totComment}} Answers</span>
        <span class="breaker">o</span>
        <span>{{postData.totLikes}} Upvotes</span>
        <span class="breaker">o</span>
        <span>{{postData.totShare}} Shares</span>
        </span>
    </div>


    <div class="p-2 border-top">
        <ul class="list-inline mb-0">
            <li class="list-inline-item">
                <a routerLink="{{baseUrl}}discuss-detail/{{postData.forum_slug}}" class="btn btn-pink-gradiant">Answer</a>
            </li>
            <!-- <li class="list-inline-item">
                    <img src="assets/images/point-coin.png" alt="Points" class="mr-1 coin-sm"> +25
                </li> -->
            <li class="list-inline-item">
                <a href="javascript:void(0)" (click)="addRemoveUpvote(postData.forum_id, 'forum')"><img src="assets/images/upvote.svg" alt="Points" class="mr-1"> Upvote </a>
            </li>
            <li class="list-inline-item">
                <a href="javascript:void(0)" (click)="openShare('/discuss/discuss-detail/'+postData.forum_slug)"><img src="assets/images/share.svg" alt="Points" class="mr-1"> Share</a>
            </li>
            <li class="list-inline-item">
                <a href="javascript:void(0)" routerLink="{{baseUrl}}discuss-detail/{{postData.forum_slug}}"><i class="fa fa-eye" aria-hidden="true"></i> View</a>
            </li>
        </ul>
    </div>

</div>


